import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ConfirmProvider } from 'material-ui-confirm';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import AppErrorBoundary from '../../AppErrorBoundary';
import HeadContextProvider from '../context/HeadContext';
import LayoutContextProvider from '../../components/Layout/LayoutContext';

const withProviders =
  (ComponentDefinition: React.ComponentType) => (props: any) =>
    (
      <AppErrorBoundary>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
            <ConfirmProvider>
              <HeadContextProvider>
                <LayoutContextProvider
                  hideAppBar={props.hideAppBar}
                  newTheme={props.newTheme}
                >
                  <ComponentDefinition {...props} />
                </LayoutContextProvider>
              </HeadContextProvider>
            </ConfirmProvider>
          </I18nProvider>
        </LocalizationProvider>
      </AppErrorBoundary>
    );

export default withProviders;
